import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment,
  Typography,
} from '@mui/material';
import { getAllEmployees } from 'src/services/employeeService';
import { EmployeeInformation } from 'src/models/employee';
import SearchIcon from '@mui/icons-material/Search';

interface EmployeeDropDownProps {
  value: string | string[] | [],
  onChange: (e: any) => void,
  disabled?: boolean;
}

const EmployeeDropDown = forwardRef((props: EmployeeDropDownProps, _ref) => {
  const [resources, setResources] = useState<EmployeeInformation[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  useEffect(() => {
    const fetchResources = () => {
      getAllEmployees().then((res) => {
        const sortedData = res.data.filter(e => !e?.employeeFinance?.isResign).sort((a, b) =>
        b.createdOn.localeCompare(a.createdOn));
        setResources((sortedData as EmployeeInformation[]) || []);
      });
    }

    fetchResources();
  }, []);


  const filteredResources = useMemo(
    () =>
      resources.length > 0 &&
      resources?.filter((option) => containsText(option?.name, searchText)),
    [resources, searchText]
  );

  useEffect(() => {
    const resourcesSelectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = resources.filter(e => e.employeeId.toString() === props?.value[i]);
        resourcesSelectedName.push(result[0]?.name);
      }
    }
  }, [resources, props?.value]);

  return (
    <FormControl fullWidth disabled={props?.disabled ? props?.disabled : false}>
      <Typography fontWeight="light" variant="h5">
        Employee<span style={{ color: 'red' }}>*</span>
      </Typography>
      <Select
        id="employee-select"
        MenuProps={{ autoFocus: false }}
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        size="small"
        displayEmpty
        value={props.value}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
      >
        <ListSubheader>
          <TextField
            id="search-stakeholderRole"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        <MenuItem
          style={{ display: 'none' }}
          selected
          disabled
          value={''}
        >
          Select Employee
        </MenuItem>
        {
          filteredResources?.length > 0 &&
          filteredResources.map((resource, i) => {
            return (
              <MenuItem key={resource?.employeeId} 
                value={resource?.employeeId}>
                  <ListItemText primary={resource?.name} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default EmployeeDropDown;
